import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ShieldCheck, TrendingUp, PackageCheck, Sparkles } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-navy">
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="clinic" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-navy/70" />
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-brand-teal flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <div className="text-white">
              <div className="font-heading font-bold text-lg leading-tight">Youngness Centre</div>
              <div className="text-brand-slate text-xs tracking-widest uppercase">by Dr. Awish</div>
            </div>
          </div>
        </div>
        <div className="relative z-10 space-y-6">
          <h1 className="text-white font-heading text-4xl xl:text-5xl font-bold tracking-tight leading-[1.1]">
            Procurement &<br />Inventory Intelligence
          </h1>
          <p className="text-slate-300 max-w-md">
            Track spend, savings and vendor performance across Sarita Vihar, Mathura, Jaipur & Institute — powered by an AI procurement analyst.
          </p>
          <div className="flex flex-wrap gap-4 text-slate-200 text-sm">
            <span className="flex items-center gap-2"><TrendingUp className="w-4 h-4 text-brand-emerald" /> Savings tracking</span>
            <span className="flex items-center gap-2"><PackageCheck className="w-4 h-4 text-brand-teal" /> Multi-branch stock</span>
            <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-brand-emerald" /> Vendor SLAs</span>
          </div>
        </div>
        <div className="relative z-10 text-slate-400 text-xs">© 2026 Youngness Centre. Internal procurement tool.</div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 animate-fade-up">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="w-10 h-10 rounded-xl bg-brand-teal flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div className="font-heading font-bold text-navy">Youngness Centre</div>
          </div>
          <h2 className="font-heading text-2xl font-bold text-navy">Welcome back</h2>
          <p className="text-brand-slate mt-2 text-sm">Sign in to access the procurement dashboard.</p>
          <Button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="w-full mt-8 h-12 bg-navy hover:bg-navy/90 text-white text-base gap-3 active:scale-95 transition-transform">
            <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" opacity=".9"/><path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" opacity=".7"/><path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" opacity=".5"/><path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" opacity=".8"/></svg>
            Continue with Google
          </Button>
          <p className="text-xs text-brand-slate mt-6 text-center">
            First user becomes Admin (Dr. Awish). Roles for teammates can be set from the Team page.
          </p>
        </div>
      </div>
    </div>
  );
}
